<template>
	<!-- 全屏容器 -->
	<div class="filter-page full-page">
		<!-- 筛选栏 -->
		<div class="search-bar">
			<el-select clearable="false" v-model="schoolSemesterId" placeholder="请选择学期"  style="width: 220px; margin-left: 10px"
				@change="toSemester()">
				<el-option v-for="item in semesterList" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-select clearable="false" v-model="gradeId" placeholder="请选择年级"  style="width: 120px; margin-left: 10px"
				@change="tograde()">
				<el-option v-for="item in gradeList" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-select clearable="false" v-model="classId" placeholder="请选择班级"  style="width: 120px; margin-left: 10px"
				:disabled="gradeId===0" @change="toclass()">
				<el-option v-for="item in classList" :key="item.id" :label="item.classAlias" :value="item.id" />
			</el-select>

			<el-select clearable="false" v-model="subjectId" :disabled="gradeId===0" placeholder="请选择学科"  style="width: 120px; margin-left: 10px"
				@change="toSubject()">
				<el-option v-for="item in subjectLists" :key="item.value" :label="item.label"
					:value="item.value" />
			</el-select>
		</div>

		<!-- 列表 -->
		<div class="list-box">
			<el-table :data="list" border stripe style="width:100%;">
				<el-table-column prop="id" label="课堂ID" width="100" />
				<el-table-column prop="courseName" label="课程名称" />
				<el-table-column prop="className" label="班级名称" />
				<el-table-column prop="subject" label="学科">
					<template #default="{row}">
						{{forSubjectName(row.subject)}}
					</template>
				</el-table-column>
				<el-table-column prop="grade" label="年级">
					<template #default="{row}">
						{{forgradeName(row.grade)}}
					</template>
				</el-table-column>
				<el-table-column prop="teacherName" label="授课教师" />
				
				<el-table-column prop="status" label="课堂状态" width="100">
					<template #default="{row}">
						<el-tag :type="row.status == 1 ? 'success' : 'info'">
							{{ row.status == 1 ? '正常' : '已结束' }}
						</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" width="180">
				<template #default="{row}">
						{{forTimestamp(row.createTime)}}
					</template>
				</el-table-column>
				
				<el-table-column prop="" label="操作" width="180">
					<template #default="{row}">
						<el-button type="text" @click="toClass(row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>


			<!-- 分页 -->
			
		</div>
		<el-pagination v-model:current-page="pageNum" v-model:page-size="pageSize" :total="total"
						layout="total, sizes, prev, pager, next, jumper" @size-change="getList" @current-change="getList"
						style="text-align: center; margin-top: 20px" />
	</div>
</template>

<script>
	import {
		forGradeList,
		forSubjectList
	} from "@/js/standard.js";
	
	
	export default {
		name: "FilterListPage",
		data() {
			return {
				gradeId: 0,
				classId: 0,
				subjectId: -1,
				schoolSemesterId:'-1',
				pageNum: 1,
				pageSize: 10,
				schoolId: localStorage.getItem('orgId'),
				schoolName: localStorage.getItem('oraName'),
				teacherId: localStorage.getItem('userId'),
				list: [],
				total: 0,
				subjectList: [],
				gradeList: [],
				classList: [{
					id: 0,
					classAlias: '请选择班级'
				}],
				semesterList:[],
				subjectLists:[],
			};
		},
		mounted() {
			this.forSubject()
			this.forGradeList()
			this.getList();
			
			this.semester()
		},
		methods: {
			forTimestamp(timestamp) {
			  if (!timestamp) return ''
			  let date = new Date(timestamp)
			  let year = date.getFullYear()
			  let month = (date.getMonth() + 1).toString().padStart(2, '0')
			  let day = date.getDate().toString().padStart(2, '0')
			  let h = date.getHours().toString().padStart(2, '0')
			  let m = date.getMinutes().toString().padStart(2, '0')
			  let s = date.getSeconds().toString().padStart(2, '0')
			  return `${year}-${month}-${day} ${h}:${m}:${s}`
			},
			toSemester(val){
				this.getList()
				// schoolSemesterId
			},
			async semester(){
				try {
					let list = JSON.parse(localStorage.getItem('semester'))
					list=list?.map(v=>{
						var label=`${v.year}--${Number(v.year)+1}学年 ${v.term==1?'第一学期':'第二学期'}`
						return {
							...v,
							value:v.id,
							label:label
						}
					})
					this.semesterList=[{value:'-1',label:"全部学期"},...list]
					
				} catch (err) {
					this.semesterList = []
				}
			},
			async forSubject(){
				try {
					let list = JSON.parse(localStorage.getItem('subjectList'))
					this.subjectList=[{value:-1,label:"全部学科"},...list]
					this.subjectLists=this.subjectList
				} catch (err) {
					this.subjectList = []
				}
			},
			async forGradeList() {
				this.gradeList = [{
					value: 0,
					label: '请选择年级'
				}]
				const res = await this.API.get(this.API.school.getSchoolGrad, {
					schoolId: this.schoolId
				});
				if (res.data && res.data.data) {
					let list = res.data.data.map(grade => {
						return {
							value: grade.grade,
							label: grade.gradeName,
						};
					});
					if (list.length > 0) {
						this.gradeList = [...this.gradeList, ...list]
					}
				}
			},
			forgradeName(id){
				var name = this.gradeList.filter(v => v.value == id)[0].label || ''
				return name
			},
			forSubjectName(id) {
				var name = this.subjectList.filter(v => v.value == id)[0].label || ''
				return name
			},
			tograde() {
				this.classId = 0
				this.pageNum = 1
				this.getList()
				this.subjectId=-1
				if (this.gradeId !== 0) {
					this.forClassList()
					var stageCode=this.gradeId<7?1:this.gradeId<10?2:3
					this.subjectLists=this.subjectList?.filter(v=>v.stageCode==stageCode||!v.stageCode)
				}else{
					this.subjectLists=this.subjectList
				}

			},
			async forClassList() {
				this.classList = [{
					id: 0,
					classAlias: '请选择班级'
				}]
				let res = await this.API.get(this.API.school.getSchoolGradClass, {
					schoolId: this.schoolId,
					gradeId: this.gradeId
				})
				var list = res.data.data || []
				if (list.length > 0) {
					this.classList = [...this.classList, ...list]
				}

			},
			toclass() {
				this.pageNum = 1
				this.getList()
			},
			toSubject() {
				this.pageNum = 1
				this.getList()
			},
			// forSubject() {
			// 	let subjectList = forSubjectList()
			// 	this.subjectList = [{
			// 		value: 0,
			// 		label: "请选择学科"
			// 	}, ...subjectList]
			// },
			async getList(pange) {
				if (pange) {
					this.pageNum = pange
				}
				// 接口统一用 query 里的参数
				this.API.post(this.API.school.getTeacherClassList, {
					schoolId: this.schoolId,
					teacherId: this.teacherId,
					courseStatus: 2,
					subject: this.subjectId == -1 ? '' : this.subjectId,
					grade: this.gradeId == 0 ? '' : this.gradeId,
					classId: this.classId == 0 ? "" : this.classId,
					pageNum: this.pageNum,
					pageSize: this.pageSize,
					schoolSemesterId:this.schoolSemesterId==-1?null:this.schoolSemesterId
				}).then(res => {
					this.list = res.data.data.records
					this.total = res.data.data.total
				})
			},
			toClass(row) {
			
				localStorage.setItem('courseClassId',row.id)
				localStorage.setItem('customPageId', row.customPageId)
				localStorage.setItem('courseId', row.courseId)
				localStorage.setItem('isSave',true)
				this.$router.push({
					path: '/teacher/interactiveClassroom',
					query: {
						courseClassId:row.id,
						courseName:row.courseName,
						isSave:true,
					}
				})
			},
		}
	};
</script>

<style scoped>
	/* 全屏铺满 */
	.full-page {
		width: 100% !important;
		height: 100% !important;
		margin: 0 !important;
		padding: 15px !important;
		box-sizing: border-box !important;
	}

	.filter-page {
		background: #fff;
		min-height: calc(100vh - 80px);
	}

	.search-bar {
		margin-bottom: 20px;
	}

	/* 列表盒子100%宽度 */
	.list-box {
		width: 100%;
		height: 80%;
		overflow-y: auto;
		background: #fff;
		padding: 0;
		border-radius: 8px;
		box-shadow: 0 2px 10px #00000010;
	}

	/* 表格100%宽度 */
	::v-deep .el-table {
		width: 100% !important;
	}
</style>